<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Avaliação</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Inicio</a></li>
          <li class="breadcrumb-item">Professor</li>
          <li class="breadcrumb-item active">Avaliação</li>
        </ol>
      </div>
    </div>
    <div class="col-sm-8">
      <p v-if="AssessmentStatus.Assessment === true">
        <span v-if="AssessmentStatus.Assessment === true">
          <i class="mdi mdi-information text-info"></i>
          Ja é possível fazer o lançamento das notas frequência dos estudantes
        </span>
        <span v-if="AssessmentStatus.Assessment === false">
          <i class="mdi mdi-information text-info"></i>
          O lançamento das notas dos estudantes encontra-se neste momento
          fechado!
        </span>
      </p>
      <p v-if="AssessmentStatus.Exames === true">
        <span v-if="AssessmentStatus.Exames === true">
          <i class="mdi mdi-information text-info"></i>
          Ja é possível fazer o lançamento das notas dos exames!
        </span>
        <span v-if="AssessmentStatus.Exames === false">
          <i class="mdi mdi-information text-info"></i>
          O lançamento das notas dos estudantes encontra-se neste momento
          fechado!
        </span>
      </p>

      <p
        v-if="
          AssessmentStatus.Exames === false &&
          AssessmentStatus.Assessment === false
        "
      >
        <span v-if="AssessmentStatus.Exames === false">
          <i class="mdi mdi-information text-info"></i>
          Ainda nao é possível fazer o lançamento das notas dos estudantes,
          encontra-se neste momento fechado!
        </span>
      </p>
    </div>
  </div>

  <div
    v-if="formulaString != ''"
    style="background-color: #d5ecbf"
    class="p-2 mb-2"
  >
    <p>
      <strong>Formula de Usada para o Calculo das Notas de Frequencia:</strong>
      {{ formulaString }}
    </p>
    <p>
      <strong>Formula de Usada para o Calculo do Exame Normal:</strong>
      {{ formulaExString }}
    </p>
    <p>
      <strong>Formula de Usada para o Calculo do Exame da Recorrencia:</strong>
      {{ formulaRecString }}
    </p>
  </div>

  <div class="row">
    <div class="col-xl-12 col-xxl-8 col-lg-8">
      <div class="card">
        <div class="card-body">
          <div class="pt-3">
            <div class="settings-form">
              <h4 class="text-primary mb-3">
                Lançamento das Notas de Frequência
              </h4>
              <span><strong>Disciplina</strong>: {{ subject.name }}</span>

              <div class="float-right col-lg-3 mb-1">
                <select
                  v-if="AssessmentStatus.Assessment === true"
                  class="form-control"
                  style="border-radius: 16px"
                  v-model="assessment_type"
                >
                  <option disabled value="">Selecionar avaliação</option>
                  <option
                    :value="header"
                    v-for="header in headerTitleSelect.filter(
                      (item) =>
                        item !== 'EXAME-NORMAL' && item !== 'RECORRENCIA'
                    )"
                    :key="header"
                  >
                    {{ header }}
                  </option>
                </select>
                <select
                  v-if="AssessmentStatus.Exames === true"
                  class="form-control"
                  style="border-radius: 16px"
                  v-model="assessment_type"
                >
                  <option disabled value="">Selecionar avaliação</option>
                  <option value="EXAME-NORMAL">EXAME-NORMAL</option>
                  <option value="RECORRENCIA">RECORRENCIA</option>
                </select>
              </div>
              <form @submit.prevent="submitAssessments">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="mainHeaderTable" scope="col">#</th>
                        <th id="mainHeaderTable" scope="col">
                          NOME DO ESTUDANTE
                        </th>
                        <th id="mainHeaderTable" scope="col">
                          Nº DO ESTUDANTE
                        </th>
                        <th
                          id="mainHeaderTable"
                          scope="col"
                          v-for="header in headerTitle"
                          :key="header"
                        >
                          {{ header }}
                        </th>
                        <th id="mainHeaderTable" scope="col">MÉD. FREQ</th>
                        <th id="mainHeaderTable" scope="col">
                          RESULTADO FREQUÊNCIA
                        </th>
                        <th id="mainHeaderTable" scope="col">EXAME-NORMAL</th>
                        <th id="mainHeaderTable" scope="col">RECORRENCIA</th>
                        <th id="mainHeaderTable" scope="col">MÉD. FINAL</th>
                        <th id="mainHeaderTable" scope="col">
                          RESULTADO FINAL
                        </th>
                      </tr>
                    </thead>
                    <!-- {{
                      dataStudents
                    }} -->
                    <tbody>
                      <tr
                        v-for="(students, index) in dataStudents"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ students.fullName }}</td>
                        <td>{{ students.card_id }}</td>
                        <td v-for="header in headerTitle" :key="header">
                          <input
                            v-if="students[header] != null"
                            type="text"
                            class="form-control"
                            :disabled="header !== assessment_type"
                            @input="
                              onGradeChange(
                                students.id,
                                header,
                                students[header],
                                students,
                                students[`${header}_id`],
                                students[`${header}_Fid`],
                                students[`${header}_percentage`],
                                students.studentHaveBeenEvaluate
                              )
                            "
                            v-model="students[header]"
                            style="width: 40px; font-size: 12px; padding: 10px"
                          />
                          <input
                            v-else
                            type="text"
                            class="form-control"
                            :disabled="header !== assessment_type"
                            @input="
                              onGradeChange(
                                students.id,
                                header,
                                students[header],
                                students,
                                header_id,
                                students[`${header}_Fid`],
                                students[`${header}_percentage`],
                                students.studentHaveBeenEvaluate
                              )
                            "
                            v-model="students[header]"
                            style="width: 40px; font-size: 12px; padding: 10px"
                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            class="form-control"
                            disabled
                            :value="students_average(students).average"
                            style="width: 50px; font-size: 12px; padding: 10px"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            disabled
                            :value="students_average(students).result"
                            style="width: 150px; font-size: 12px; padding: 10px"
                          />
                        </td>

                        <td>
                          <input
                            :disabled="
                              assessment_type == 'EXAME-NORMAL' ? false : true
                            "
                            type="text"
                            class="form-control"
                            @input="
                              studentAssessmentExame(
                                students.id,
                                students,
                                students['EXAME-NORMAL'],
                                'EXAME-NORMAL',
                                students['EXAME-NORMAL_id'],
                                students['EXAME-NORMAL_percentage'],
                                students['studentHaveBeenEvaluateExame'],
                                students['EXAME-NORMAL_Fid'],
                                students['MEDIAFREQUENCIA_percentage']
                              )
                            "
                            v-model="students['EXAME-NORMAL']"
                            style="width: 50px; font-size: 12px; padding: 10px"
                          />
                        </td>
                        <td>
                          <input
                            :disabled="
                              assessment_type == 'RECORRENCIA' ? false : true
                            "
                            type="text"
                            class="form-control"
                            @input="
                              studentAssessmentExame(
                                students.id,
                                students,
                                students['RECORRENCIA'],
                                'RECORRENCIA',
                                students['RECORRENCIA_id'],
                                students['RECORRENCIA_percentage'],
                                students['studentHaveBeenEvaluateExame'],
                                students['RECORRENCIA_Fid'],
                                students['MEDIAFREQUENCIA_percentage']
                              )
                            "
                            v-model="students['RECORRENCIA']"
                            style="width: 50px; font-size: 12px; padding: 10px"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            disabled
                            :value="
                              studentAssessmentExameResult(students)
                                .finalAvarenge
                            "
                            style="width: 150px; font-size: 12px; padding: 10px"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            disabled
                            :value="
                              studentAssessmentExameResult(students).textResult
                            "
                            style="width: 150px; font-size: 12px; padding: 10px"
                          />
                        </td>
                      </tr>
                      <tr v-if="dataStudents.length == 0">
                        <td colspan="14" style="text-align: center">
                          <span style="font-style: italic">
                            Ainda sem estudantes
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Button
                  type="success"
                  class="float-right"
                  @click.prevent="submitAssessments"
                  v-if="
                    dataStudents.length > 0 &&
                    AssessmentStatus.Assessment == true
                  "
                >
                  Salvar
                </Button>
                <Button
                  v-if="
                    dataStudents.length > 0 && AssessmentStatus.Exames == true
                  "
                  type="success"
                  class="float-right"
                  @click.prevent="submitAssessmentsExam"
                >
                  Salvar
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Loading :loadingData="loading"></Loading>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import TeacherDashStoreModule from "../TeacherDashStoreModule";
import toastr from "toastr";
import store from "@/store";
import Loading from "../../../components/Loading.vue";
import SubjectStoreModule from "@/pages/subject/SubjectStoreModule";
import ClassMateStoreModule from "@/pages/Classmates/ClassMateStoreModule";
import { toast } from "vue3-toastify";

const dataStudents = ref([]);
const updateAssessment = ref([]);
const assessment_type = ref("");
const labels = ref([]);
const isDelete = ref(false);
const loading = ref(false);
const DataAssessemntStudent = ref({});
const AssessmentStatus = ref({});
const formulaString = ref("");
const formulaExString = ref("");
const formulaRecString = ref("");
const isLargeMarker = ref(false);
const headerTitle = ref([]);
const headerTitleSelect = ref([]);

const route = useRoute();
const formulas = ref([]);
const subject = ref({});
const selectedAssessment = ref(null);
const studentsResultStatus = ref([]);

/**
 * Buscar a disciplina em avaliacao
 * Author:Octavio Manuel Cossa
 *
 */
async function getSubjectAvaluation() {
  try {
    loading.value = true;

    const resp = await SubjectStoreModule.actions.viewSubject(
      route.params.subject_id
    );
    subject.value = resp.data.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

/***
 * Data: 04-04-24
 * author: Octavio Manuel Cossa
 * calcula media final(exame normal e recorrencia)
 */
function studentAssessmentExame(
  student_id,
  student,
  assesment_value,
  assessmentType,
  assessmentType_id,
  assessmentType_percentage,
  studentHaveBeenEvaluateExame,
  assessmentType_f,
  media_freq
) {
  let averange = 0;
  let finalAverange = null;
  let textResult = "";

  const existingStudent = updateAssessment.value.find(
    (item) => item.id === student_id
  );

  if (existingStudent) {
    existingStudent[assessmentType] = assesment_value;
  } else {
    updateAssessment.value.push({
      id: student_id,
      [`${assessmentType}`]: assesment_value,
      assessmentType_id: assessmentType_id || null,
      assessmentType_percentage: assessmentType_percentage || null,
      studentHaveBeenEvaluateExame: studentHaveBeenEvaluateExame,
      assessment_form_id: assessmentType_f || null,
      isExame: "yes",
    });
  }

  averange =
    assesment_value * assessmentType_percentage +
    students_average(student).average * media_freq;
  if (students_average(student).average >= 14) {
    return { finalAvarenge: null, textResult: null };
  }
  finalAverange = averange / 140;
  if (finalAverange == NaN) {
    finalAverange = null;
  } else {
    if (finalAverange < 10) {
      textResult = "Reprovado";
    } else {
      textResult = "Aprovado";
    }
  }
}

// Return result
function studentAssessmentExameResult(student) {
  let averange = 0;
  let finalAverange = null;
  let textResult = "Reprovado";
  let normalExam = false;
  let recoExam = false;

  console.log("student", student);

  if (
    format_Value(student["EXAME-NORMAL"]) > 20 ||
    format_Value(student["EXAME-NORMAL"]) < 0
  ) {
    student["EXAME-NORMAL"] = 0;
    isLargeMarker.value = true
    return toastr.info(
      "A nota nao pode ser inferior 0 ou superior que 20 valores"
    );
  }
  if (
    format_Value(student["RECORRENCIA"]) > 20 ||
    format_Value(student["RECORRENCIA"]) < 0
  ) {
    isLargeMarker.value = true

    student["RECORRENCIA"] = 0;
    return toastr.info(
      "A nota nao pode ser inferior 0 ou superior que 20 valores"
    );
  }
  isLargeMarker.value = false

  if (format_Value(student["EXAME-NORMAL"])) {
    normalExam = true;
    console.log("normalExam", normalExam);
  }

  if (format_Value(student["RECORRENCIA"])) {
    recoExam = true;
    console.log("REc", recoExam);
  }

  if (normalExam) {
    averange =
      parseFloat(format_Value(student["EXAME-NORMAL"])) *
        parseInt(student["EXAME-NORMAL_percentage"]) +
      students_average(student).average *
        parseInt(student["MEDIAFREQUENCIA_percentage"]);
  }

  if (recoExam) {
    averange =
      parseFloat(student["RECORRENCIA"]) *
        parseInt(student["RECORRENCIA_percentage"]) +
      students_average(student).average *
        parseInt(student["MEDIAFREQUENCIA_percentage"]);
  }

  if (recoExam && normalExam) {
    averange =
      parseFloat(format_Value(student["RECORRENCIA"])) *
        parseInt(student["RECORRENCIA_percentage"]) +
      students_average(student).average *
        parseInt(student["MEDIAFREQUENCIA_percentage"]);
  }

  finalAverange = averange / 100;

  if (isNaN(finalAverange)) {
    finalAverange = null;
  } else if (finalAverange > 9) {
    textResult = "Aprovado";
  }

  return {
    finalAvarenge: finalAverange ? finalAverange.toFixed(1) : null,
    textResult: textResult,
  };
}

function format_Value(value) {
  if (!value) return null;
  return String(value).replace(",", ".");
}

/**
 *
 * calcula  media notas do estudante
 * author: Octavio Manuel Cossa
 * */
function students_average(students) {
  let average = (0).toFixed(1);
  let result = "Excluído";
  let sumOfPercentage = null;

  let somaNotas = [];
  let i = 0;
  formulas.value.forEach((element) => {
    if (students[element.assessment_type] == null) {
      students[element.assessment_type] = 0;
    }
    somaNotas[i] =
      parseFloat(students[element.assessment_type]) *
      parseInt(element.percentage);
    sumOfPercentage += parseInt(element.percentage);
    i++;
  });

  // store the sum of tests
  let s = 0;
  for (const element of somaNotas) {
    s += element;
  }

  average = (s / sumOfPercentage).toFixed(1);

  if (average >= 14) {
    result = "Dispensado";
  } else if (average >= 10 && average <= 13.9) {
    result = "Admitido";
  }

  return { average: average || null, result: result || null };
}

/**
 * Responsavel por retornar os testes que devem ser avaliados e que foram
 * adicionado na formula
 * author: Octavio Manuel Cossa
 * */
async function getFormulasSubject() {
  let formulaParts = [];
  let totalWeight = 0;

  await TeacherDashStoreModule.actions
    .getFormulaByClass(route.params.classmate_id, route.params.subject_id)
    .then((response) => {
      labels.value = response;
      response.forEach((element) => {
        if (element.percentage > 0) {
          formulas.value.push({
            id: element.id,
            assessment_type: element.assessment_type,
            percentage: element.percentage,
          });
          if (AssessmentStatus.value !== "Fechado") {
            assessment_type.value = formulas.value[0].assessment_type;
          }
          formulaParts.push(
            `${element.assessment_type} x  ${element.percentage}%`
          );

          totalWeight += element.percentage;
        }
      });
    });
  formulaString.value = formulaParts.join(" + ") + ` / ${totalWeight}`;
}

const exameF = ref(0);
const assessment_ttype = ref("");

function onGradeChange(
  student_id,
  assessmentType,
  assessment_value,
  student,
  assessment_id,
  assessment_formula_id,
  assessment_percentage,
  studentHaveBeenEvaluate
) {
  console.log("Sr", student);

  assessment_ttype.value = assessmentType;

  if (assessment_value != undefined) {
    if (assessment_value > 20 || assessment_value < 0) {
      const student = dataStudents.value.find((item) => item.id === student_id);
      student[assessmentType] = 0;
      isLargeMarker.value = true;

      return toastr.info(
        "A nota nao pode ser inferior 0 ou superior que 20 valores"
      );
    } else {
      isLargeMarker.value = false;

      const existingStudent = updateAssessment.value.find(
        (item) => item.id === student_id
      );
      let idx = updateAssessment.value.findIndex(
        (item) => item.id === student_id
      );

      if (existingStudent) {
        existingStudent[assessmentType] = format_Value(assessment_value);
        if (studentsResultStatus.value[idx]?.result === "Dispensado") {
          studentsResultStatus.value[idx].media =
            students_average(student).average;
          studentsResultStatus.value[idx].result =
            students_average(student).result;
          console.log("let me know", studentsResultStatus.value);
        } else if (studentsResultStatus.value[idx]?.result === "Excluído") {
          studentsResultStatus.value[idx].media =
            students_average(student).average;
          studentsResultStatus.value[idx].result =
            students_average(student).result;
          console.log("let me know", studentsResultStatus.value);
        } else {
          studentsResultStatus.value.splice(idx, 1);
        }
        students_average(student).result === "Excluído";
      } else {
        updateAssessment.value.push({
          assessment_id: assessment_id,
          id: student_id,
          [assessmentType]: format_Value(assessment_value),
          assessment_type: assessmentType,
          assessmentFormulaId: assessment_formula_id,
          assessmentPercentage: assessment_percentage,
          studentHaveBeenEvaluate: studentHaveBeenEvaluate,
          isExame: "no",
        });
        if (
          students_average(student)?.result === "Dispensado" ||
          students_average(student)?.result === "Excluído"
        ) {
          studentsResultStatus.value.push({
            id: student_id,
            media: students_average(student)?.average,
            result: students_average(student)?.result,
          });
          console.log("let me know", studentsResultStatus.value);
        }
      }
    }
  }
}
onMounted(async () => {
  // AssessmentStatus.value =
  //   JSON.parse(localStorage.getItem("AssessmentStatus")) || null;
  getStudentByClassMates();
  getFormulasSubject();
  getSubjectAvaluation();
  getDateilStatusLevelCalssmate();
});

/*
Verifica estado activo do exames e notas para validar a insersao das mesmas
lembrando que cada estado activo no seu periodo
*/
async function getDateilStatusLevelCalssmate() {
  try {
    loading.value = true;

    const resp =
      await ClassMateStoreModule.actions.getDateilStatusLevelCalssmate(
        route.params.classmate_id
      );
    AssessmentStatus.value = resp.data;
    console.log(resp.data);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

// avaliacao dos estudantes
async function submitAssessments() {
  try {
    loading.value = true;
    if (isLargeMarker.value === true) {
      return toast.info('Informe uma nota valida!',{
        autoClose:1000
      })
      
    }
    const resp = await TeacherDashStoreModule.actions.giveAssessmentToStudents(
      updateAssessment.value,
      route.params.subject_id,
      route.params.classmate_id,
      assessment_type.value
    );
    console.log("====================================");
    console.log(resp.data.status);
    console.log("====================================");
    if (resp.data.status) {
      return toast.success(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

// avaliacao dos estudantes (Exames)
async function submitAssessmentsExam() {
  try {
    loading.value = true;
    if (isLargeMarker.value === true) {
      return toast.info('Informe uma nota valida!',{
        autoClose:1000
      })
      
    }
    const resp =
      await TeacherDashStoreModule.actions.giveExamAssessmentToStudents(
        updateAssessment.value,
        route.params.subject_id,
        route.params.classmate_id,
        assessment_type.value
      );

    if (resp.data.status) {
      return toast.success(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

// Actualiza a nota do estudante selecionado/especifico
async function updateStudentAssessments() {
  try {
    const resp = await TeacherDashStoreModule.actions.updateStudentResult(
      DataAssessemntStudent.value,
      selectedAssessment.value
    );
  } catch (error) {
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

async function getStudentByClassMates() {
  try {
    loading.value = true;
    let formulaExParts = [];
    let formulaRecoParts = [];
    const [
      StudentResponse,
      assesmentType,
      getAssessmentExams,
      assessmentExamResult,
    ] = await Promise.all([
      TeacherDashStoreModule.actions.getStudentByClassMates(
        route.params.classmate_id,
        route.params.subject_id
      ),
      TeacherDashStoreModule.actions.getFormulaByClass(
        route.params.classmate_id,
        route.params.subject_id
      ),
      TeacherDashStoreModule.actions.getAssessmentExams(
        route.params.classmate_id,
        route.params.subject_id
      ),
      TeacherDashStoreModule.actions.getAssessmentExamsResults(
        route.params.classmate_id
      ),
    ]);

    store.dispatch("assessmentResults/assessments", StudentResponse.data);

    let students = [];
    headerTitle.value = assesmentType.map((type) => type.assessment_type); //Titulo das colunas
    headerTitleSelect.value = assesmentType.map((type) => type.assessment_type);
    getAssessmentExams.data?.data.forEach((item) => {
      if (item.assessment_type != "MEDIAFREQUENCIA") {
        headerTitleSelect.value.push(item.assessment_type);
        if (item.assessment_type === "EXAME-NORMAL") {
          formulaExParts.push(`${item.assessment_type} x ${item.percentage}%`);
        }
        if (item.assessment_type === "RECORRENCIA") {
          formulaRecoParts.push(
            `${item.assessment_type} x ${item.percentage}%`
          );
        }
      } else {
        formulaExParts.push(`${item.assessment_type}  x ${item.percentage}%`);
        formulaRecoParts.push(`${item.assessment_type} x ${item.percentage}%`);
      }
    });

    formulaExString.value = formulaExParts.join(" + ") + ` / 100`;
    formulaRecString.value = formulaExParts.join(" + ") + ` / 100`;

    StudentResponse.forEach((student) => {
      // criar o objecto base para cada estudantes

      let studentData = {
        id: student.id,
        card_id: student.student_card_id,
        fullName: student.fullName,
        textResult: "",
        finalresult: "",
        studentHaveBeenEvaluate:
          student.assessment_result.length > 0 ? "yes" : "no",
        studentHaveBeenEvaluateExame:
          assessmentExamResult.data.filter(
            (exam) =>
              exam.id === student.id && exam.assessment_exame_result.length > 0
          )[0] === undefined
            ? "no"
            : "yes",
      };
      let asseValue = getAssessmentExams.data.data.find(
        (item) => item.assessment_type === "MEDIAFREQUENCIA"
      );
      studentData[`MEDIAFREQUENCIA_percentage`] = asseValue.percentage;
      assesmentType.forEach((type) => {
        let result = student.assessment_result.find(
          (item) =>
            item.assesment_type === type.assessment_type &&
            item.subject_id === parseInt(route.params.subject_id)
        );

        studentData[type.assessment_type] = result
          ? result.assessment_value
          : null;
        // studentData["assessment_formula_id"] = result
        //   ? result.assessment_formula_id
        //   : null;
        studentData[`${type.assessment_type}_Fid`] = result
          ? result.assessment_formula_id
          : null;
        studentData[`${type.assessment_type}_percentage`] = result
          ? result.assessment_percentage
          : null;

        studentData[`${type.assessment_type}_id`] = result ? result.id : null;
      });

      headerTitleSelect.value.forEach((typ) => {
        let resultExam = assessmentExamResult.data.find(
          (exam) =>
            exam.id === student.id &&
            exam.assessment_exame_result.some(
              (item) => item.assessment_type === typ
            )
        );

        if (resultExam) {
          let examResult = resultExam.assessment_exame_result.find(
            (item) => item.assessment_type === typ
          );

          studentData[typ] = examResult ? examResult.assessment_value : null;
          studentData[`${typ}_id`] = examResult ? examResult.id : null;
          studentData[`${typ}_Fid`] = examResult
            ? examResult.assessment_exam_formula_id
            : null;
          studentData[`${typ}_percentage`] = examResult
            ? examResult.assessment_percentage
            : null;
        }
      });

      students.push(studentData);
      dataStudents.value.push(studentData);
    });
  } catch (error) {
    console.log("Qual eh erro: ", error);
  } finally {
    loading.value = false;
  }
}

function closeModal() {
  isDelete.value = false;
}

function updateStudentAssessment(students) {
  isDelete.value = true;

  let findStudent = dataStudents.value.filter(
    (item) => item.student_id == students.student_id
  );
  DataAssessemntStudent.value = findStudent;
  //  console.log("chek", item);
}
</script>

<style scoped>
tr {
  cursor: pointer;
}

#mainHeaderTable {
  font-size: 12px;
}
</style>